import React, { useContext, useState, useEffect } from 'react'

import { API } from 'API'
import { CasesPageContext } from 'containers/CasesPage/CasesPageContext'
import { RequestToasterContext } from 'containers/Providers'
import { Case } from 'domains/case'
import { ProductInfo } from 'domains/productInfo'
import { StandardErrorResponse } from 'types/APIResponses'
import { isNotNil } from 'utils/isNotNil'

const HIDDEN_PRODUCTS: ProductInfo[] = [
  ProductInfo.ODB,
  ProductInfo['Spark Junior Phase 2'],
  ProductInfo['Spark Retainers'],
]

export const CaseProduct = () => {
  const { casesPageState } = useContext(CasesPageContext)
  const { id, productInfoId } = casesPageState.userCase as Case
  const { requestStatusRef } = useContext(RequestToasterContext)

  const [productInfo, setProductInfo] = useState(productInfoId)
  const [productEnabledStates, setProductEnabledStates] = useState<
    Partial<Record<(typeof ProductInfo)[keyof typeof ProductInfo], boolean>>
  >({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (id) {
      API.getCaseProductEnabledStates(id)
        .then(setProductEnabledStates)
        .catch((error: StandardErrorResponse) => {
          requestStatusRef.current?.showAlert(error?.response?.data?.error, 'danger')
        })
        .finally(() => setIsLoading(false))
    }
  }, [id, requestStatusRef])

  const handleChangeProductInfo = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setProductInfo(event.target.value as (typeof ProductInfo)[keyof typeof ProductInfo])

  const handleUpdateProduct = () => {
    if (!productInfo) {
      return
    }

    setIsLoading(true)
    API.updateCaseById({ id, productInfoId: productInfo })
      .then(() => requestStatusRef.current?.showAlert('Updated', 'success'))
      .catch((error: StandardErrorResponse) => {
        requestStatusRef.current?.showAlert(error.response.data.error, 'danger')
      })
      .finally(() => setIsLoading(false))
  }

  const isCurrentProductDisabled =
    productInfoId == ProductInfo.ODB ||
    productInfoId == ProductInfo['Spark Passive Aligners'] ||
    productInfoId == ProductInfo.Retainers ||
    productInfoId == ProductInfo['Spark Junior Phase 2'] ||
    productInfoId == ProductInfo['Spark Retainers']

  return (
    <tr>
      <td>Product</td>
      <td>
        {isNotNil(productInfoId) && (
          <form>
            <select
              name="productInfoId"
              value={productInfo}
              onChange={handleChangeProductInfo}
              className="w-50"
              disabled={isCurrentProductDisabled || isLoading}>
              {Object.entries(ProductInfo)
                .filter(
                  ([_, value]) =>
                    !HIDDEN_PRODUCTS.includes(value) ||
                    HIDDEN_PRODUCTS.includes(String(productInfoId) as ProductInfo),
                )
                .map(([key, value], index) => (
                  <option
                    key={`${value}-${index}`}
                    value={value}
                    disabled={!productEnabledStates[value]}>
                    {key}
                  </option>
                ))}
            </select>
            <button
              onClick={handleUpdateProduct}
              disabled={isCurrentProductDisabled || isLoading}
              className="float-right"
              type="button">
              Update
            </button>
          </form>
        )}
      </td>
    </tr>
  )
}
